<template>
  <div class="swiper-container container-h-auto" ref="swiper">
    <div class="swiper-wrapper">
      <!--v-img 
			class="swiper-slide slide-h-auto -slide-16-9"
			v-for="img,i in collection" :key="i"
			:src="img.sm" 
			:lazy-src="img.lg" 
			:min-width="320"
			@error="onImageError"
			@load="onImageLoad"
      ></v-img-->
      <img :src="img.lg" v-for="(img,i) in collection" :key="i" class="swiper-slide slide-h-auto" />
    </div>

    <div class="swiper-pagination"></div>

    <div class="swiper-nav fill-height">
      <v-container class="swiper-nav-container">
        <v-btn
          @click="prevSlide"
          small
          fab
          light
          absolute
          left
          class="swiper-nav-btn prev"
          color="white"
        >
          <v-icon small>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn
          @click="nextSlide"
          small
          fab
          light
          absolute
          right
          class="swiper-nav-btn next"
          color="white"
        >
          <v-icon small>mdi-chevron-right</v-icon>
        </v-btn>
      </v-container>
    </div>
    <div class="advert-photo-shadow"></div>
  </div>
</template>

<script>
import _ from "lodash";
import { Swiper, Navigation, Pagination } from "swiper/dist/js/swiper.esm.js";

const placeholder =
  "data:image/jpeg;base64,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";

export default {
  name: "Photos",

  props: ["images"],

  data: () => ({
    swiper: null
  }),

  computed: {
    root_url: function() {
      return window._API + "media/";
    },

    /**
     * example:
     * {
     * "uuid":"02db6510-7dfc-4b5f-84d1-8824ce87d372",
     * "parent_uuid":"60df66e9-d63a-421c-9bc7-115d76a35565",
     * "urls":{
     * 		"lg":"02db6510-7dfc-4b5f-84d1-8824ce87d372_lg.jpg",
     * 		"sm":"02db6510-7dfc-4b5f-84d1-8824ce87d372_sm.jpg"
     * 	},
     * 	"ordering":2,
     * 	"uploaded_by":"610cbd81-c7a4-4a59-7357-dab4ae5abc81",
     * 	"uploaded_at":"2019-08-23 16:32:47",
     * 	"deleted_at":null
     * 	}
     * @return {array}
     */
    collection: function() {
      let empty = [
        {
          urls: {
            lg: placeholder,
            sm: placeholder
          }
        }
      ];
      let input = _.get(this.$props, "images", empty);
      if (input.length < 1) {
        return [
          {
            lg: placeholder,
            sm: placeholder
          },
          {
            lg: placeholder,
            sm: placeholder
          },
          {
            lg: placeholder,
            sm: placeholder
          }
        ];
      }
      return _.mapValues(input, image => {
        let thumb_url = _.get(image, "urls.sm", null);
        if (!thumb_url) {
          thumb_url = placeholder;
        } else {
          thumb_url = this.root_url + thumb_url;
        }
        let image_url = _.get(image, "urls.lg", null);
        if (!image_url) {
          image_url = placeholder;
        } else {
          image_url = this.root_url + image_url;
        }
        return {
          lg: image_url,
          sm: thumb_url
        };
      });
    }
  },

  methods: {
    loadSwiper: function() {
      // if (this.swiper != null) return;

      Swiper.use([Pagination]);
      this.swiper = new Swiper(this.$refs.swiper, {
        loop: true,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets"
        },
        loopAdditionalSlides: 3,
        loopedSlides: 3
      });

      this.swiper.on("slideChange", () => {
        this.$forceUpdate();
        this.swiper.update();
      });
    },

    onImageError: function(e) {
      // console.log('onImageError', e)
    },

    onImageLoad: function(e) {
      this.$nextTick(function() {
        this.$forceUpdate();
        this.swiper.update();
      });
    },

    prevSlide: function(e) {
      return this.swiper.slidePrev();
    },

    nextSlide: function(e) {
      return this.swiper.slideNext();
    }
  },

  mounted: function() {
    this.loadSwiper();
    // document.addEventListener("DOMContentLoaded", () => this.loadSwiper());
  }
};
</script>

<style lang="css" scoped>
.v-image__image--preload {
  filter: blur(5px);
}
.swiper-nav {
  position: absolute;
  width: 100%;
  top: 0px;
  pointer-events: none;
}
.swiper-nav-container {
  position: relative;
  top: 50%;
  margin-top: -20px;
  pointer-events: none;
  padding: 0px;
}
.swiper-nav-btn {
  pointer-events: auto;
  z-index: 2;
}

.swiper-slide.slide-h-auto {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  width: auto;
  height: 100%;
  max-height: 320px;
}

.container-h-auto {
  max-height: 320px;
}
@media (max-width: 600px) {
  .swiper-slide.slide-h-auto,
  .container-h-auto {
    max-height: 420px;
  }
}
@media (max-width: 960px) {
  .swiper-slide.slide-h-auto,
  .container-h-auto {
    max-height: 480px;
  }
}
@media (max-width: 1264px) {
  .swiper-slide.slide-h-auto,
  .container-h-auto {
    max-height: 600px;
  }
}
@media (max-width: 1094px) {
  .swiper-slide.slide-h-auto,
  .container-h-auto {
    max-height: 600px;
  }
}
@media (min-width: 1095px) {
  .swiper-slide.slide-h-auto,
  .container-h-auto {
    max-height: 720px;
  }
}
.advert-photo-shadow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 40px;
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 0),
    rgba(0, 0, 0, 0.4)
  );
  z-index: 5;
}
</style>